import React from 'react'

class AbstractArea extends React.Component {
  isAA() {
    return true
  }
}

export default AbstractArea
